import userTieIcon from "../../../assets/images/userTieIcon.svg";
import { customAttrDisplay } from "../../PointOfSale/Core/modals/customAttributes/displayValue";
import Offers from "../../../assets/images/promoTag.svg";
import NotesImage from "../../../assets/images/notes.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import userAddIcon from "../../../assets/images/userAddIcon.svg";

/**
 * Parked bill table column definitions.
 */
export const parkedBillColumns = [
  { title: "Parked Sale", dataIndex: "parkedTime", key: "parkedTime", width: "20%" },
  { title: "Document No", dataIndex: "parkedDocNo", key: "parkedDocNo", width: "25%" },
  { title: "Customer", dataIndex: "customer", key: "customer", width: "20%" },
  { title: "Qty", dataIndex: "qty", key: "qty", width: "20%" },
  { title: "Status", dataIndex: "status", key: "status", width: "15%" },
];

/**
 * Cash management table column definitions.
 */
export const cashManagementColumns = [
  { title: "Date", dataIndex: "date", key: "date", width: "30%" },
  { title: "Customer", dataIndex: "customer", key: "customer", width: "30%" },
  { title: "Reasons", dataIndex: "note", key: "note", width: "33%" },
  {
    title: "Transactions(Rs)",
    dataIndex: "amount",
    key: "amount",
    width: "20%",
    render: (text, record) => {
      return record.cashAddInFlag === true ? <span style={{ color: "red" }}>-{record.amount}</span> : record.amount;
    },
  },
];

/**
 * Returns the column definitions for the pre-order cart table.
 */
export const getCartColumns = ({
  posConfig,
  cart,
  pricePrecision,
  currenciesList,
  selectProductInCart,
  selectedRowKeys,
  setShowPaymentMethods,
  clearSelectedProductInCart,
  removeProductModal,
  setIsInputFocused,
  setShowInputFields,
  setCustomMixItems,
  setGroupQty,
  setActiveInput,
  searchInputRef,
  setNotesPopup,
  setNotesValue,
  setSelectedProductForNotes,
  setOpenSalesRep,
}) => [
  {
    title: "Item Name",
    dataIndex: "name",
    key: "name",
    width: "28%",
    render: (text, record) => {
      return (
        <>
          <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
            {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
              <>
                {record.salesRepName ? (
                  <>
                    <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                    <span>{record.salesRepName}</span>
                  </>
                ) : (
                  cart.salesRepName && (
                    <>
                      <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                      <span>{cart.salesRepName}</span>
                    </>
                  )
                )}
              </>
            ) : null}
          </div>

          <div
            onClick={() => {
              if (cart.type !== "Layaway") {
                selectProductInCart(record);
                selectedRowKeys.length > 0 && record.productId ? setShowPaymentMethods(false) : "";
              }
            }}
            id="sm-product-name"
            className="tableRow"
            style={{
              textAlign: "left",
              marginLeft: 0,
              display: "flex",
              alignItems: "center",
            }}
          >
            {record.name}
          </div>
          <div className="offerName" style={{}}>
            <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>
            {record.newCustomAttributes &&
              record.newCustomAttributes.length > 0 &&
              Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                const display = customAttrDisplay(value);
                if (!display) return null;
                return (
                  <p key={key} style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                    {key} - {display}
                  </p>
                );
              })}

            {record.selectedAddons &&
              record.selectedAddons.length > 0 &&
              record.selectedAddons.map((item) => {
                return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
              })}
            {record.batchedProduct === "Y" && record.batchedForSale === "Y" && record.batchno && (
              <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>Batch: {record.batchno}</p>
            )}
            {(() => {
              const uomName = record?.uomData?.[0]?.name || record?.selectedUom?.name || record?.uom_name || "";
              return uomName ? <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic", fontSize: "0.75em" }}>UOM: {uomName}</p> : null;
            })()}

            {Math.abs(record.discount) > 0 && record.discountName ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  marginTop: "2px",
                  padding: "2px 8px",
                  backgroundColor: "#FFF7E0",
                  border: "1px solid #F8C519",
                  color: "#7A5A00",
                  borderRadius: "10px",
                  fontSize: "0.72em",
                  lineHeight: 1.2,
                  fontWeight: 500,
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <img src={Offers} alt="" width={12} height={12} />
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{record.discountName}</span>
              </span>
            ) : null}
          </div>
        </>
      );
    },
  },
  {
    title: "Qty",
    dataIndex: "weight",
    key: "weight",
    width: "11%",
    render: (text, record) => {
      const wt = parseFloat(text);
      if (Number.isInteger(wt)) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
          </div>
        );
      } else {
        return (
          <>
            <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
            <div className="offerName">
              {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
            </div>
          </>
        );
      }
    },
    align: "center",
  },
  {
    title: "Discount",
    dataIndex: "discount",
    key: "discount",
    width: "11%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Tax",
    dataIndex: "taxAmount",
    key: "taxAmount",
    width: "11%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">
            {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
          </span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Price",
    dataIndex: "realPrice",
    key: "realPrice",
    width: "10%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Total",
    dataIndex: "nettotal",
    key: "nettotal",
    width: "15%",
    render: (text) => {
      return (
        <div style={{ position: "relative" }}>
          <span className="tableRow" style={{ width: "12%", left: "0" }}>
            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            {parseFloat(text).toFixed(pricePrecision)}
            &nbsp;
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          </span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "",
    dataIndex: "",
    key: "",
    width: "10%",
    render: (text, record) => {
      if (record.groupedItems === true) return null;
      return (
        <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
          <img
            src={DeleteProduct}
            onClick={(e) => {
              e.stopPropagation();
              clearSelectedProductInCart();
              removeProductModal(record);
              setIsInputFocused(false);
              setShowInputFields(false);
              setCustomMixItems([]);
              setGroupQty(1);
              setActiveInput("search");
              if (searchInputRef?.current) {
                searchInputRef?.current.focus();
              }
            }}
            id="sm-product-delete"
            style={{
              height: "2.5vh",
              cursor: "pointer",
              top: "15%",
            }}
          />
          {posConfig?.enableLineLevelNarration === "Y" && (
          <img
            onClick={(e) => {
              e.stopPropagation();
              clearSelectedProductInCart();
              setNotesPopup(true);
              setIsInputFocused(true);
              setNotesValue(record.notes);
              setSelectedProductForNotes(record);
              selectProductInCart(record);
              setIsInputFocused(false);
            }}
            src={NotesImage}
            alt="Notes"
            title="Add Note"
            style={{
              height: "2.5vh",
              cursor: "pointer",
              opacity: 0.7,
            }}
          />
          )}
          {posConfig?.showLineSalesRep === "Y" && (
            <img
              src={userAddIcon}
              style={{ height: "2.5vh", cursor: "pointer", paddingTop: "1px" }}
              alt=""
              onClick={() => {
                setOpenSalesRep({ flag: true, level: "line" });
              }}
            />
          )}
        </div>
      );
    },
    align: "center",
  },
];
